import type { MonitoringResponse } from "@synthesis/shared-services/internal/monitoring/types";
import { MonitoringCard } from "./monitoring-card";
import { MonitoringMetric } from "./monitoring-metric";
import { MonitoringSectionHeading } from "./monitoring-section-heading";
import {
  ACTIVE_DEADLINE_METRICS,
  ACTIVE_FINANCE_METRICS,
  ACTIVE_INVOICE_METRICS,
  ACTIVE_PAYMENT_METRICS,
  getMonitoringMetrics,
  MONITORING_SECTION_TOOLTIPS,
} from "../monitoring-page.lib";

export const ActiveApplicationsSection = ({ railwayId, data }: { railwayId: string; data: MonitoringResponse }) => (
  <section className="flex flex-col gap-6">
    <MonitoringSectionHeading
      title="Показатели по активным заявкам"
      tooltipTitle={MONITORING_SECTION_TOOLTIPS.active.title}
      tooltipDescription={MONITORING_SECTION_TOOLTIPS.active.description}
    />

    <MonitoringCard
      title="Контроль срока рассмотрения"
      extra={
        data.reviewPeriodWorkingDays != null ? (
          <p className="subtitle-sm text-type-minor">Срок рассмотрения: {data.reviewPeriodWorkingDays} рабочих дней</p>
        ) : undefined
      }
    >
      <div className="flex gap-3">
        {getMonitoringMetrics(ACTIVE_DEADLINE_METRICS, railwayId, data).map((metric) => (
          <MonitoringMetric key={metric.id} metric={metric} />
        ))}
      </div>
    </MonitoringCard>

    <div className="grid grid-cols-3 gap-6">
      <MonitoringCard title="Условия оплаты">
        <div className="flex flex-col gap-2">
          {getMonitoringMetrics(ACTIVE_PAYMENT_METRICS, railwayId, data).map((metric) => (
            <MonitoringMetric key={metric.id} metric={metric} percentPlacement="inline" className="flex-none" />
          ))}
        </div>
      </MonitoringCard>

      <MonitoringCard title="Состояния счетов">
        <div className="flex flex-col gap-2">
          {getMonitoringMetrics(ACTIVE_INVOICE_METRICS, railwayId, data).map((metric) => (
            <MonitoringMetric key={metric.id} metric={metric} percentPlacement="inline" className="flex-none" />
          ))}
        </div>
      </MonitoringCard>

      <MonitoringCard title="Финансовые показатели">
        <div className="flex flex-col gap-2">
          {getMonitoringMetrics(ACTIVE_FINANCE_METRICS, railwayId, data).map((metric) => (
            <MonitoringMetric key={metric.id} metric={metric} percentPlacement="inline" className="flex-none" />
          ))}
        </div>
      </MonitoringCard>
    </div>
  </section>
);
